/**
 * Automation Who Section
 *
 * Edit mode UI for configuring WHO the automation applies to.
 * Used inline within AutomationCard when editing the "Who" section.
 */

import { useFormikContext } from 'formik';
import { FC } from 'react';
import { Box } from 'src/components/Box';

import { AutomationFilters } from '../AutomationFilters';
import { AutomationItem, FilterNode } from '../types';

interface AutomationWhoSectionProps {
  automation: AutomationItem;
  index: number;
  allowedFilterTypes?: ReadonlyArray<FilterNode['type']>;
}

export const AutomationWhoSection: FC<AutomationWhoSectionProps> = ({
  automation,
  index,
  allowedFilterTypes,
}) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Box>
      <AutomationFilters
        value={automation.filters}
        allowedFilterTypes={allowedFilterTypes}
        onChange={(filters) => {
          setFieldValue(`automations.${index}.filters`, filters);
        }}
      />
    </Box>
  );
};
